import {
	GET_FAVORITES,
	GET_FAVORITES_SUCCESS,
	GET_FAVORITES_FAILURE,
	DELETE_FAVORITE_SUCCESS,
	DELETE_FAVORITE_SNAP,
	ADD_FAVORITE_SNAP,
	LOAD_MORE_FAVORITES,
	LOAD_MORE_FAVORITES_SUCCESS,
} from './types';

export const getFavoritesAction = (payload?: any) => ({
	type: GET_FAVORITES,
	payload,
});

export const getFavoritesSuccessAction = (payload: any) => ({
	type: GET_FAVORITES_SUCCESS,
	payload,
});

export const getFavoritesFailureAction = (error: Error) => ({
	type: GET_FAVORITES_FAILURE,
	payload: error,
});

export const removeFavoriteAction = (payload: any) => ({
	type: DELETE_FAVORITE_SNAP,
	payload,
});

export const removeFavoriteSuccessAction = (payload: any) => ({
	type: DELETE_FAVORITE_SUCCESS,
	payload,
});

export const addFavoriteSnapAction = (payload: any) => ({
	type: ADD_FAVORITE_SNAP,
	payload,
});

export const loadMoreFavoritesSuccessAction = (payload: any) => ({
	type: LOAD_MORE_FAVORITES_SUCCESS,
	payload,
});

export const loadMoreFavoritesAction = (payload: any) => ({
	type: LOAD_MORE_FAVORITES,
	payload,
});
